import type { Request } from '@app/src/types/resourceExplorer'
import { FormatListNumberedOutlined, InfoOutlined, MenuBookOutlined, ShareOutlined } from '@mui/icons-material'
import { Button, Paper, Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import SidebarAccessorsList from './SidebarAccessorsList'

interface AssessmentDetailsSidebarProps {
  onLearnMoreClick: () => void
  onMethodologyClick: () => void
  onViewQuestionnaireClick: () => void
  onShareDataClick: () => void
  isViewQuestionnaireDisabled: boolean
  hideViewQuestionnaire?: boolean
  request: Request | undefined
}

const AssessmentDetailsSidebar: React.FC<AssessmentDetailsSidebarProps> = ({
  onLearnMoreClick,
  onMethodologyClick,
  onViewQuestionnaireClick,
  onShareDataClick,
  isViewQuestionnaireDisabled,
  hideViewQuestionnaire = false,
  request,
}) => {
  const { formatMessage } = useIntl()

  return (
    <Stack width="100%" spacing={3}>
      <Paper
        elevation={0}
        sx={{
          p: 3,
          '&:hover': { bgcolor: 'grey.200', transition: 'background 0.2s' },
        }}
      >
        <Stack spacing={2} alignItems="stretch">
          <Typography variant="subtitle1">{formatMessage({ id: 'assessments.shareData' })}</Typography>
          <Typography color="text.secondary">{formatMessage({ id: 'assessments.shareDataDescription' })}</Typography>
          <Button startIcon={<ShareOutlined />} variant="contained" onClick={onShareDataClick}>
            {formatMessage({ id: 'assessments.share' })}
          </Button>
        </Stack>
      </Paper>
      <Stack spacing={2} alignItems="flex-start">
        <Button startIcon={<InfoOutlined />} onClick={onLearnMoreClick} sx={{ justifyContent: 'flex-start' }}>
          {formatMessage({ id: 'general.learnMore' })}
        </Button>
        <Button startIcon={<MenuBookOutlined />} onClick={onMethodologyClick} sx={{ justifyContent: 'flex-start' }}>
          {formatMessage({ id: 'assessment.tabs.methodology' })}
        </Button>
        {!hideViewQuestionnaire && (
          <Button
            startIcon={<FormatListNumberedOutlined />}
            onClick={onViewQuestionnaireClick}
            disabled={isViewQuestionnaireDisabled}
            sx={{ justifyContent: 'flex-start' }}
          >
            {formatMessage({ id: 'assessments.viewQuestionnaire' })}
          </Button>
        )}
      </Stack>
      <SidebarAccessorsList request={request} />
    </Stack>
  )
}

export default AssessmentDetailsSidebar
